/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lg-container[_ngcontent-%COMP%]{padding:1rem}.input-box[_ngcontent-%COMP%]{display:flex;align-items:center;margin-top:5px}.input-box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:90%}form[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(3,1fr);align-items:center}.unit[_ngcontent-%COMP%]{margin-left:3px}"];
export { styles as styles };
